import React, { useMemo } from 'react'
import { useAudio } from '../../context/AudioContext'

function extractAudioSrc(html) {
    if (!html) return null

    const doc = new DOMParser().parseFromString(html, 'text/html')

    const sourceTag = doc.querySelector('audio source')
    const audioTag = doc.querySelector('audio')

    if (sourceTag?.src) return sourceTag.src
    if (audioTag?.src) return audioTag.src

    const links = Array.from(doc.querySelectorAll('a'))
    const audioLink = links.find((link) =>
        /\.(mp3|m4a|wav|ogg)(\?.*)?$/i.test(link.href)
    )

    return audioLink?.href || null
}

function removeNativeAudioPlayers(html) {
    if (!html) return ''

    const doc = new DOMParser().parseFromString(html, 'text/html')

    doc.querySelectorAll('audio').forEach((node) => node.remove())
    doc.querySelectorAll('figure.wp-block-audio').forEach((node) => node.remove())
    doc.querySelectorAll('.wp-audio-shortcode').forEach((node) => node.remove())

    return doc.body.innerHTML
}

function decodeHtmlEntities(text) {
    const parser = new DOMParser()
    const doc = parser.parseFromString(text, 'text/html')
    return doc.documentElement.textContent || ''
}

export default function Post(props) {
    const post = props.post
    const { playTrack, currentTrack, isPlaying } = useAudio()

    const audioSrc = useMemo(() => {
        return extractAudioSrc(post?.content?.rendered)
    }, [post])

    const cleanedContent = useMemo(() => {
        return removeNativeAudioPlayers(post?.content?.rendered)
    }, [post])

    const isCurrentTrack = currentTrack?.src === audioSrc

    const handlePlay = () => {
        if (!audioSrc) return

        const cleanTitle = decodeHtmlEntities(
            post?.title?.rendered?.replace(/<[^>]+>/g, '') || 'Episode'
        )

        playTrack({
            title: cleanTitle,
            src: audioSrc,
        })
    }

    return (
        <div className="episode">
            <article>
                <h1
                    id="title"
                    dangerouslySetInnerHTML={{ __html: post.title.rendered }}
                />

                <p id="date">{post.formatted_date}</p>

                {audioSrc && (
                    <div className="episode-player-launcher">
                        <button
                            className="episode-player-launcher__button"
                            type="button"
                            onClick={handlePlay}
                        >
                            {isCurrentTrack && isPlaying ? 'Playing Now' : 'Play Episode'}
                        </button>
                    </div>
                )}

                <div
                    id="cont"
                    dangerouslySetInnerHTML={{ __html: cleanedContent }}
                />
            </article>
        </div>
    )
}